import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class HeaderService {

    public reciveProjectNameSubject: BehaviorSubject<any>;
    public reciveProjectNameObservable: Observable<any>;
    public reciveProjectIdSubject: BehaviorSubject<any>;
    public reciveProjectIdObservable: Observable<any>;
    constructor() {
        this.reciveProjectNameSubject = new BehaviorSubject<any>(null);
        this.reciveProjectNameObservable = this.reciveProjectNameSubject.asObservable();

        this.reciveProjectNameObservable.subscribe(data => {

        });


        this.reciveProjectIdSubject = new BehaviorSubject<any>(null);
        this.reciveProjectIdObservable = this.reciveProjectIdSubject.asObservable();

        this.reciveProjectIdObservable.subscribe(data => {

        });
    }
}
